if (!customElements.get("product-form")) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form[data-type="add-to-cart-form"]');
      this.formSample = this.querySelector("[data-product-sample-form]");
      this.formButtonSample = this.querySelector("[data-add-sample-button]");

      // get main product form submission
      this.form.addEventListener("submit", this.onSubmitHandler.bind(this));

      this.cartNotification = document.querySelector("cart-notification");
      this.cartDrawer = document.querySelector("cart-drawer");
      this.cartItems = document.querySelector("cart-items");
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      let currentForm;
      let submitButton;
      let addToCartBehavior =
        this.form.querySelector('[type="submit"]').dataset.addToCartBehavior;

      // get the submit button according to the form submitted - the main or sample
      if (evt.target == this.form) {
        currentForm = this.form;
        submitButton = this.querySelector('[type="submit"]');
      } else if (evt.target == this.formButtonSample) {
        currentForm = this.formSample;
        submitButton = this.formButtonSample;
      }

      submitButton.setAttribute("disabled", true);
      submitButton.classList.add("loading");

      const config = fetchConfig("javascript");
      config.headers["X-Requested-With"] = "XMLHttpRequest";
      delete config.headers["Content-Type"];

      const sectionsToFetch = [
        ...this.cartNotification
          .getSectionsToRender()
          .map((section) => section.id),
      ];
      // Update the Cart drawer, if in the Product page
      sectionsToFetch.push(
        ...this.cartDrawer.getSectionsToRender().map((section) => section.id)
      );

      const formData = new FormData(currentForm);
      formData.append("sections", sectionsToFetch);
      formData.append("sections_url", window.location.pathname);
      config.body = formData;

      // Prevent adding more than stock
      const requestedQty = parseInt(formData.get("quantity"), 10);
      const availableQty = parseInt(formData.get("inventory_quantity"), 10);
      const variantId = formData.get("id");

      let existingQtyInCart = 0;

      try {
        const cartResponse = await fetch("/cart.js");
        const cartData = await cartResponse.json();

        const matchingItem = cartData.items.find(
          (item) => item.id == variantId
        );
        if (matchingItem) existingQtyInCart = matchingItem.quantity;
      } catch (err) {
        console.error("Cart fetch failed:", err);
      }

      if (requestedQty + existingQtyInCart > availableQty) {
        this.cartNotification.setActiveElement(document.activeElement);
        this.cartNotification.renderQuantityError(availableQty);

        submitButton.classList.remove("loading");
        submitButton.removeAttribute("disabled");
        return;
      }

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((parsedState) => {
          if (parsedState.status == 422) {
            // When quantity error
            this.cartNotification.setActiveElement(document.activeElement);
            this.cartNotification.renderQuantityError(
              formData.get("inventory_quantity")
            );
            return;
          }

          this.cartDrawer.renderContents(parsedState);

          switch (addToCartBehavior) {
            case "open_cart_drawer":
              this.cartDrawer.open();
              break;
            case "show_cart_notification":
            default:
              this.cartNotification.setActiveElement(document.activeElement);
              this.cartNotification.renderContents(parsedState);
          }
        })
        .then((response) => {
          return this.cartItems.addFreeProductToCart();
        })
        .then(() => {
          if (window.location.pathname !== "/cart") {
            this.cartItems.updateLiveRegions();
            this.cartItems.refreshInterface();
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove("loading");
          if (evt.target == this.form) submitButton.removeAttribute("disabled");
        });
    }
  }

  window.ProductForm = ProductForm;
  customElements.define("product-form", ProductForm);
}
